import React, { useState } from "react"
import { useLocation, navigate } from "@reach/router"
import { Link } from "gatsby"
import * as styles from "./LanguageSwitcher.module.scss"
import { FaGlobe } from "react-icons/fa"

import {
  mapLocale,
  mapLangSelector,
} from "../../utils/mapping"

const getLangCodeFromPath = (pathname: string): "en-US" | "ja-JP" | "ar" | "en-AE" | "en-GB" => {
  if (pathname.startsWith("/in/en/")) return "en-US"
  if (pathname.startsWith("/jp/ja/")) return "ja-JP"
  if (pathname.startsWith("/mena/ar/")) return "ar"
  if (pathname.startsWith("/mena/en/")) return "en-AE"
  if (pathname.startsWith("/uk/en/")) return "en-GB"
  return "en-US"
}

const getPathForLang = (
  currentPath: string,
  targetLangCode: "en-US" | "ja-JP" | "ar" | "en-AE" | "en-GB"
) => {
  const segments = currentPath.split("/").filter(Boolean)
  if (segments.length < 2) return `/${mapLocale[targetLangCode]}/`

  const newSegments = [...segments]
  const [country, locale] = mapLocale[targetLangCode].split("/")
  newSegments[0] = country
  newSegments[1] = locale

  return `/${newSegments.join("/")}/`
}

const LanguageSwitcher = ({languageSwitcherText}) => {
  const location = useLocation()
  const [open, setOpen] = useState(false)

  const currentLangCode = getLangCodeFromPath(location.pathname)

  const handleLangClick = (targetLangCode: "en-US" | "ja-JP" | "ar" | "en-AE" | "en-GB") => {
    const targetPath = getPathForLang(location.pathname, targetLangCode)

    setOpen(false)

    if (targetLangCode !== currentLangCode) {
      navigate(targetPath)
    }
  }

  return (
    <div className={styles.dropdownWrapper}>
      <button
        className={styles.dropdownToggle}
        onClick={() => setOpen(prev => !prev)}
        aria-haspopup="true"
        aria-expanded={open}
      >
        <FaGlobe className={styles.icon} />
        <span>{languageSwitcherText}</span>
      </button>

      {open && (
      
        <ul className={styles.dropdownMenu}>
  {Object.entries(mapLangSelector).map(([langCode, label]) => (
    <li key={langCode}>
      <button
        onClick={() => handleLangClick(langCode as "en-US" | "ja-JP" | "ar" | "en-AE" | "en-GB")}
        className={`${styles.linkButton} ${
          currentLangCode === langCode ? styles.active : ""
        }`}
      >
        {label}
      </button>
    </li>
  ))}
</ul>

      )}
    </div>
  )
}

export default LanguageSwitcher
